import React from 'react';
import Header from '../header/Header';
import './bodyContainer.scss';

function BodyContainer(props) {
  return (
    <div className="stepper-body-container">
      <Header {...props} />
      {props.children}
    </div>
  );
}

export default BodyContainer;